import type { Badge } from '@nordhealth/components'

export type InvoiceTypes = (typeof InvoiceType)[keyof typeof InvoiceType]
export const InvoiceType = {
  Consultation: 'CONSULTATION',
  CounterSale: 'COUNTERSALE',
  CreditNote: 'CREDIT_NOTE',
  Consolidated: 'CONSOLIDATED_INVOICE',
  Unknown: 'UNKNOWN',
} as const

export type InvoicePaymentStatuses =
  (typeof InvoicePaymentStatus)[keyof typeof InvoicePaymentStatus]
export const InvoicePaymentStatus = {
  Paid: 'PAYMENT_STATUS_PAID',
  Unpaid: 'PAYMENT_STATUS_UNPAID',
  PartiallyPaid: 'PAYMENT_STATUS_PARTIALLY_PAID',
} as const

export type InvoicePaymentTransactionStatuses =
  (typeof InvoicePaymentTransactionStatus)[keyof typeof InvoicePaymentTransactionStatus]
export const InvoicePaymentTransactionStatus = {
  Pending: 'PAYMENT_STATUS_PENDING',
  Cancelled: 'PAYMENT_STATUS_CANCELLED',
  Paid: 'PAYMENT_STATUS_PAID',
  Failed: 'PAYMENT_STATUS_FAILED',
} as const

export type InvoiceStatuses = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]
export const InvoiceStatus = {
  Draft: 'INVOICE_DRAFT',
  Sent: 'INVOICE_SENT',
  Open: 'INVOICE_OPEN',
  Finalized: 'INVOICE_FINALIZED',
  Invoicing: 'INVOICE_INVOICING',
  Voided: 'INVOICE_VOIDED',
} as const
export const InvoiceStatusBadgeMap: Record<InvoiceStatuses, Badge['variant']> =
  {
    INVOICE_DRAFT: 'warning',
    INVOICE_SENT: 'warning',
    INVOICE_OPEN: 'warning',
    INVOICE_INVOICING: 'info',
    INVOICE_VOIDED: 'danger',
    INVOICE_FINALIZED: 'success',
  }
export const InvoiceStatusFilters = {
  Draft: 'INVOICE_DRAFT',
  Finalized: 'INVOICE_FINALIZED',
} as const

export type InvoiceVATDeterminingTypes =
  (typeof InvoiceVATDeterminingType)[keyof typeof InvoiceVATDeterminingType]
export const InvoiceVATDeterminingType = {
  InclVat: 'VAT_DETERMINING_INCL_VAT',
  ExclVat: 'VAT_DETERMINING_EXCL_VAT',
} as const

export type InvoiceVATCalculationMethods =
  (typeof InvoiceVATCalculationMethod)[keyof typeof InvoiceVATCalculationMethod]
export const InvoiceVATCalculationMethod = {
  ByItem: 'VAT_CALCULATION_BY_ITEM',
  ByTotal: 'VAT_CALCULATION_BY_TOTAL',
} as const
